import { connect } from 'react-redux';
import ModalTransferBonusCard from './index';
import { mapStateToProps, mapDispatchToProps } from './index.props';

export default connect(mapStateToProps, mapDispatchToProps)(ModalTransferBonusCard);
